export default class MetaInfoBuilder {

  constructor() {
    this._description = undefined
    this._image = undefined
    this._title = undefined
  }

  description(value) {
    this._description = value
    return this
  }

  image(value) {
    this._image = value
    return this
  }

  title(value) {
    this._title = value.toUpperCase()
    return this
  }

  general() {
    return [
      { vmid: 'description', name: 'description', content: this._description },
    ]
  }

  facebook() {
    const tags = [
      { vmid: 'og:description', property: 'og:description', content: this._description },
      { vmid: 'og:site_name', property: 'og:site_name', content: 'CHEF NATURELLE' },
      { vmid: 'og:title', property: 'og:title', content: this._title },
      { vmid: 'og:type', property: 'og:type', content: 'website' },
      { vmid: 'og:url', property: 'og:url', content: window.location.href },
    ]

    if (this._image) {
      tags.push({ vmid: 'og:image', property: 'og:image', content: this._image })
    }

    return tags
  }

  twitter() {
    const tags = [
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { vmid: 'twitter:description', name: 'twitter:description', content: this._description },
      { vmid: 'twitter:title', name: 'twitter:title', content: this._title },
    ]

    if (this._image) {
      tags.push({ vmid: 'twitter:image', name: 'twitter:image', content: this._image })
    }

    return tags
  }

  build() {
    return {
      meta: [
        ...this.general(),
        ...this.facebook(),
        ...this.twitter(),
      ],
      title: this._title,
    }
  }
}
